module.exports = function getResource(label) {
    const resources = {
        sameDayDelivery: 'Same-Day Delivery ',
        standard: 'Standard ',
        item: 'Item',
        items: 'Items'
    };

    return resources[label];
};
